import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { Money } from "@/lib/domain/Money";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface OperationNormaliseUnitAmountRequestModel {
	readonly normalisedUnitAmount: Money;
}

export interface OperationNormaliseUnitAmountRequestProperties {
	readonly requestModel: OperationNormaliseUnitAmountRequestModel;
	readonly collectionId: string;
}

export const useOperationNormaliseUnitAmount = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, OperationNormaliseUnitAmountRequestProperties> = (requestProperties: OperationNormaliseUnitAmountRequestProperties) => {
		return http<undefined, OperationNormaliseUnitAmountRequestModel>({
			method: "POST",
			url: "/collection/" + requestProperties.collectionId + "/operation/normalise-unit-amount",
			body: requestProperties.requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestProperties) => {
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
			queryClient.invalidateQueries({ queryKey: ["collection", requestProperties.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["collectionVariantDetails", requestProperties.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["dashboardCurrentPosition"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardHistoricalPositions"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardPerformanceDeltas"] });
			queryClient.invalidateQueries({ queryKey: ["transactionSummaries"] });
			queryClient.invalidateQueries({ queryKey: ["transactions", requestProperties.collectionId] });
		}
	});
};
